import useFormatter from '@hooks/useFormatter';
import { MenuItem } from '@material-ui/core';
import React from 'react';
import { ComboField, ComboFieldProps } from './Fields/ComboField';

export enum EnumCompetenciaMode {
    CurrentOnly = 1,
    CurrentAndBefore = 2,
    CurrentAndAfter = 3
}

export type ComboCompetenciaModeProps = ComboFieldProps & {
    competencia?: string
}

export function ComboCompetenciaMode ({ competencia, children, ...props }: ComboCompetenciaModeProps) {
    const formatter = useFormatter();

    const competenciaString = formatter.toCompetencia(competencia);

    return (    
        <ComboField {...props}>
            <MenuItem value={EnumCompetenciaMode.CurrentOnly}>Somente {competenciaString}</MenuItem>
            <MenuItem value={EnumCompetenciaMode.CurrentAndBefore}>Até {competenciaString}</MenuItem>
            <MenuItem value={EnumCompetenciaMode.CurrentAndAfter}>De {competenciaString} em diante</MenuItem>
        </ComboField>
    )
}